
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FallingLeavesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (250 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (0.5 + layerIndex * 0.2) * 100 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            const driftP = this.pseudoRandom(x);
            const scrollY = (time * speed) % spacing;
            
            for (let y = y1; y <= y2; y += spacing) {
                const rot = time * (0.5 + driftP) + (x + y);
                const sway = Math.sin(time + x) * 20;
                const size = (8 + driftP * 12) * scale;
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + sway, y + scrollY);
                    ctx.rotate(rot);
                    ctx.beginPath();
                    ctx.ellipse(0, 0, size, size * 0.4, 0, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
